<template>
    <div>
        <show-poster
            :slug="row.show.slug"
            :width="60"
            :mobile-width="60"
            @click="$emit('component-click', 'show-poster')"
        />
        <div>
            <h4>{{ row.show.symbol }}</h4>
            <h3 @click="$emit('component-click', 'show-name')">{{ row.show.name }}</h3>
            <span class="subtext">{{ row.show.location.name.replace('Theatre', '') }}</span>
            <span class="subtext show-meta">
                <show-type-indicator :type="row.show.type"/>
                <span v-if="row.performances > 0">
                    <span class="performance-indicator">{{ row.performances }}</span> Perf.
                </span>
                <span v-if="row.previews > 0">
                    <span class="performance-indicator">{{ row.previews }}</span> Prev.
                </span>
            </span>
        </div>
    </div>
</template>

<script>
import cl from 'src/util/cloudinary';
import ShowPoster from 'src/components/ShowPoster';
import ShowTypeIndicator from 'src/components/ShowTypeIndicator';

export default {
    props: ['row'],
    computed: {
        image() {
            if (!this.row.show.image) {
                return false;
            }

            return cl.url(this.row.show.image, {
                width: 96,
                crop: 'scale',
                fetch_format: 'auto',
            });
        },
    },
    components: {
        ShowTypeIndicator,
        ShowPoster,
    },
};
</script>
